document.addEventListener("DOMContentLoaded", function () {
    var fadeInUpIcons = document.querySelectorAll('.icons-row__slider, .carousel');
    const ViewPointobserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.clientWidth == entry.target.scrollWidth) {
                    entry.target.style.animation = 'fadeInUp 1s forwards';
                } else if (entry.target.clientWidth < entry.target.scrollWidth) {
                    entry.target.style.animation = 'fadeInSliderRightToLeft 1s forwards';
                }
            } else {
                entry.target.style.animation = 'fadeOut 1s forwards';
            }
        })
    })
    fadeInUpIcons.forEach((element) => {
        ViewPointobserver.observe(element);
    });
});